'use client'
import EditIcon from '@/app/icons/edit'
import { EditContext } from '@/context/edit-manager'
import { cn } from '@/util/cn'
import { IGif } from '@giphy/js-types'
import { useContext } from 'react'

type Props = {
    gif: IGif
    className?: string
}

const EditButton = ({ gif, className }: Props) => {
    const { addToEdit } = useContext(EditContext)
    return (
        <EditIcon
            className={cn('size-5 transition-transform hover:scale-110', className)}
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                addToEdit(gif.id)
            }}
        />
    )
}

export default EditButton
